import { HttpRequest } from '@angular/common/http';

export const HTTP_HEADER_W3C_BAGGAGE = 'baggage';

type Key = 'eventCorrId' | 'language';

export class W3cBaggage {
    readonly #baggage: Record<string, string>;

    constructor(request?: HttpRequest<unknown>) {
        this.#baggage = this.#decode(request?.headers.get(HTTP_HEADER_W3C_BAGGAGE));
    }

    add(key: Key, value: string | undefined): W3cBaggage {
        if (value) {
            this.#baggage[key] = value;
        } else {
            delete this.#baggage[key];
        }
        return this;
    }

    toString(): string | undefined {
        return (
            Object.entries(this.#baggage)
                .filter(([, value]) => !!value)
                .map(e => e.join('='))
                .join() || undefined
        );
    }

    #decode(value: string | undefined | null): Record<string, string> {
        const defaultValue = {} as Record<string, string>;
        if (!value) {
            return defaultValue;
        }
        return value.split(',').reduce((acc, curr) => {
            const [key, value] = curr.split('=') as [string, string];
            acc[key] = value;
            return acc;
        }, defaultValue);
    }
}
